export enum OrderAccessRoleLabel {
  MANAGER = 'Editor',
  VIEWER = 'Viewer',
  GROUP_CUSTOM_OFFER_VIEWER = 'Group Custom Offer Viewer',
}

interface RoleAction {
  id: string;
  label: string;
  description?: string;
}

export enum OrderAccessRole {
  MANAGER = 'MANAGER',
  VIEWER = 'VIEWER',
  GROUP_CUSTOM_OFFER_VIEWER = 'GROUP_CUSTOM_OFFER_VIEWER',
}

export const ROLE_ACTIONS: Record<App.OrderAccessRole, Array<RoleAction>> = {
  MANAGER: [
    { id: 'upgrade', label: 'Upgrade rooms' },
    { id: 'cancel', label: 'Cancel the booking' },
    { id: 'change-dates', label: 'Change booking dates' },
  ],
  VIEWER: [
    { id: 'view', label: 'Only view booking details', description: 'They cannot perform any self-service actions' },
  ],
  GROUP_CUSTOM_OFFER_VIEWER: [
    { id: 'view', label: 'Only view booking details', description: 'They cannot perform any self-service actions' },
  ],
};
